// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__QmvHn","label":"Section_label__1Uomg","contentWrap":"Section_contentWrap__35ag9","footer":"Section_footer__kFpXp","footerInner":"Section_footerInner__3KBZH"};